<script setup lang="ts">
import { DropdownMenuGroup } from 'reka-ui';
</script>

<template>
    <DropdownMenuGroup>
        <slot />
    </DropdownMenuGroup>
</template>
